//  culturals

export const culturalsData = [
    {
        name: "Sahil Verma",
        email: "sahilver.18@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB001"
    },
    {
        name: "Devraj Singh AMB",
        email: "devrajsingh20105@acropolis.in",
        domain: "Battle of Bands",
        hash: "BOB002"
    },
    {
        name: "Karan Singh Thakur",
        email: "karanthakur20709@acropolis.in",
        domain: "Battle of Bands",
        hash: "BOB003"
    },
    {
        name: "Rahul Karma",
        email: "rahulkarmamba2022@acropolis.in",
        domain: "Battle of Bands",
        hash: "BOB004"
    },
    {
        name: "Shashank Siroliya",
        email: "siloriyashashank@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB005"
    },
    {
        name: "Srujan Sahi",
        email: "gudulcuty@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB006"
    },
    {
        name: "Anshul sathe",
        email: "pgaming645@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB007"
    },
    {
        name: "Kushagra Jain",
        email: "mail.kushagr.jain@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB008"
    },
    {
        name: "Yashasvee Iyer",
        email: "yash02.iyer@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB009"
    },
    {
        name: "Aditya Bhattamishra",
        email: "aadityabhattmishra@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB010"
    },
    {
        name: "Devroop Sarkar",
        email: "debroopsarkar810@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB011"
    },
    {
        name: "Pravakar Bhattacharya",
        email: "pravakar.bhattacharya2020@vitbhopal.ac.in",
        domain: "Battle of Bands",
        hash: "BOB012"
    },
    {
        name: "Winston Thomas",
        email: "winston.varghese2020@vitbhopal.ac.in",
        domain: "Battle of Bands",
        hash: "BOB013"
    },
    {
        name: "Pranay Upadhyay",
        email: "pranayupadhyay44@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB014"
    },
    {
        name: "Benet Braganza",
        email: "benet0503@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB015"
    },
    {
        name: "Aman Ansari",
        email: "jazzraven500@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB016"
    },
    {
        name: "Laksh Thamman",
        email: "lakshthamman06@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB017"
    },
    {
        name: "Sarvesh George",
        email: "Sarveshgeorge34710@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB018"
    },
    {
        name: "Samarth Patrikar",
        email: "patrikarsamarth@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB019"
    },
    {
        name: "Pravigya Jain",
        email: "pravigyajain7@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB020"
    },
    {
        name: "Harsh Mahajan",
        email: "harshnandan11@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB021"
    },
    {
        name: "Shivansh Jain",
        email: "shivanshjain3333@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB022"
    },
    {
        name: "Keshav Upadhyay",
        email: "Keshavupadhyay2003@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB023"
    },
    {
        name: "Yash Manocha",
        email: "yashmanocha124@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB024"
    },
    {
        name: "Abeer Mehta",
        email: "abeermehtapercussions@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB025"
    },
    {
        name: "Mrigank Yadav",
        email: "yadav.mrigank2@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB026"
    },
    {
        name: "Abeer Lele",
        email: "abeer99back@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB027"
    },
    {
        name: "Ruchir Parkhi",
        email: "parkhi52@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB028"
    },
    {
        name: "Animesh Arya",
        email: "ani.arya722@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB029"
    },
    {
        name: "Anagh pandit",
        email: "anaghpandit@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB030"
    },
    {
        name: "Aditya Jain",
        email: "jainaditya210@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB031"
    },
    {
        name: "Utkarsh Chaure",
        email: "Utk4rshnwork@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB032"
    },
    {
        name: "Devendra Bangar",
        email: "yashbangar4141@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB033"
    },
    {
        name: "Jayraj Moyal",
        email: "jayrajmoyal04@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB034"
    },
    {
        name: "Yash Agnibhoj",
        email: "Yashagnibhoj@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB035"
    },
    {
        name: "Gopal Kashyap",
        email: "Kashyapgopal711@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB036"
    },
    {
        name: "Yuvraj singh",
        email: "Yuvrajsingh15a@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB037"
    },
    {
        name: "Sameer sharma",
        email: "sameer622sharmaji@gmail.co",
        domain: "Battle of Bands",
        hash: "BOB038"
    },
    {
        name: "Rushil yadav",
        email: "Rushilyadav2001@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB039"
    },
    {
        name: "Naitk agrawal",
        email: "naitikagrawal0307@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB040"
    },
    {
        name: "Sunny khan",
        email: "rnkhan82.ak@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB041"
    },
    {
        name: "Shivansh Saxena",
        email: "Shivanshsax12@gmail.com",
        domain: "Battle of Bands",
        hash: "BOB042"
    },
    {
        name: "Tanmay Thakre",
        email: "tanmaythakre2801@gmail.com",
        domain: "Voice of Fluxus",
        hash: "VOF001"
    },
    {
        name: "Swapnil Joshi",
        email: "joshiswapnil2004@gmail.com",
        domain: "Voice of Fluxus",
        hash: "VOF002"
    },
    {
        name: "Manas Gupta",
        email: "gupta.manas85@gmail.com",
        domain: "Voice of Fluxus",
        hash: "VOF003"
    },
    {
        name: "Maoli Sharma",
        email: "maolisharma@gmail.com",
        domain: "Voice of Fluxus",
        hash: "VOF004"
    },
    {
        name: "Anuj dubey",
        email: "anuj4728dubey@gmail.com",
        domain: "Voice of Fluxus",
        hash: "VOF005"
    },
    {
        name: "Mayank Ramnani",
        email: "phd2201101004@iiti.ac.in",
        domain: "Voice of Fluxus",
        hash: "VOF006"
    },
    {
        name: "Gourav Manohar Sardar",
        email: "gsardar05@gmail.com",
        domain: "Voice of Fluxus",
        hash: "VOF007"
    },
    {
        name: "Dikeshwar Halba",
        email: "phd2101151002@iiti.ac.in",
        domain: "Voice of Fluxus",
        hash: "VOF008"
    },
    {
        name: "Amrut Kotasthane",
        email: "amrut.kotasthane@gmail.com",
        domain: "Voice of Fluxus",
        hash: "VOF009"
    },
    {
        name: "Arjama Pal",
        email: "arjama.pal2020@vitbhopal.ac.in",
        domain: "Voice of Fluxus",
        hash: "VOF010"
    },
    {
        name: "Khushi Nagar",
        email: "khushinagar976@gmail.com",
        domain: "Voice of Fluxus",
        hash: "VOF011"
    },
    {
        name: "Arohan Bhattacharjee",
        email: "arohanb2004@gmail.com",
        domain: "Voice of Fluxus",
        hash: "VOF012"
    },
    {
        name: "P C Uma Mahesh",
        email: "pcumamahesh@gmail.com",
        domain: "Voice of Fluxus",
        hash: "VOF013"
    },
    {
        name: "Aman Masih",
        email: "(aman547134@gmail.com)",
        domain: "Voice of Fluxus",
        hash: "VOF014"
    },
    {
        name: "Sheetal Parteti",
        email: "sheetalparteti2002@gmail.com",
        domain: "Voice of Fluxus",
        hash: "VOF015"
    },
    {
        name: "Sanjay tiwari",
        email: "sanjaykumart8989@gmail.com",
        domain: "Voice of Fluxus",
        hash: "VOF016"
    },
    {
        name: "Deepika Sharma",
        email: "deepikasharmadeepikasharma465@gmail.com",
        domain: "Voice of Fluxus",
        hash: "VOF017"
    },
    {
        name: "Ashish Kumar Sahoo",
        email: "ashish.sahoo1143@gmail.com",
        domain: "Hunkaar",
        hash: "HNK001"
    },
    {
        name: "Priyanshu Hota",
        email: "priyanshuhota.ph@gmail.com",
        domain: "Hunkaar",
        hash: "HNK002"
    },
    {
        name: "Aditi Jain",
        email: "to.aditii.jain@gmail.com",
        domain: "Hunkaar",
        hash: "HNK003"
    },
    {
        name: "Purvi Baranwal",
        email: "purvi.wk@gmail.com",
        domain: "Hunkaar",
        hash: "HNK004"
    },
    {
        name: "Shreeman Daman Agrawal",
        email: "damanagrawal02@gmail.com",
        domain: "Hunkaar",
        hash: "HNK005"
    },
    {
        name: "Rohan Kumar Agrawal",
        email: "rohanagrawalbgr@gmail.com",
        domain: "Hunkaar",
        hash: "HNK006"
    },
    {
        name: "Shashank Mani Singh",
        email: "shashankmani03012002@gmail.com",
        domain: "Hunkaar",
        hash: "HNK007"
    },
    {
        name: "V Shashank",
        email: "vshashank226@gmail.com",
        domain: "Hunkaar",
        hash: "HNK008"
    },
    {
        name: "Aryansh Bagde",
        email: "aryanshbagde41@gmail.com",
        domain: "Hunkaar",
        hash: "HNK009"
    },
    {
        name: "Pratham Asati",
        email: "prathamasati@gmail.com",
        domain: "Hunkaar",
        hash: "HNK010"
    },
    {
        name: "Disha Mohanty",
        email: "dishamohanty2002@gmail.com",
        domain: "Hunkaar",
        hash: "HNK011"
    },
    {
        name: "Ankush Kumar Lohani",
        email: "lohani.ankush01@gmail.com",
        domain: "Hunkaar",
        hash: "HNK012"
    },
    {
        name: "Sayambika Das",
        email: "sayambika24@gmail.com",
        domain: "Hunkaar",
        hash: "HNK013"
    },
    {
        name: "Siddharth Singh Bhadauria",
        email: "18siddharth18@gmail.com",
        domain: "Hunkaar",
        hash: "HNK014"
    },
    {
        name: "Ayush Kumar Pathak",
        email: "ayushkumarpathak1234@gmail.com",
        domain: "Hunkaar",
        hash: "HNK015"
    },
    {
        name: "Kruti Deepa Behera",
        email: "deepakruti2001@gmail.com",
        domain: "Hunkaar",
        hash: "HNK016"
    },
    {
        name: "Rishabh Singh Bisen",
        email: "rishabhrsb15@gmail.com",
        domain: "Hunkaar",
        hash: "HNK017"
    },
    {
        name: "Parth Shah",
        email: "parthshah30112@gmail.com",
        domain: "Hunkaar",
        hash: "HNK018"
    },
    {
        name: "Amrit Kalash",
        email: "amritkalash9523@gmail.com",
        domain: "Hunkaar",
        hash: "HNK019"
    },
    {
        name: "Rashmiranjan Jena",
        email: "rashmiranjan3469@gmail.com",
        domain: "Hunkaar",
        hash: "HNK020"
    },
    {
        name: "Harsh Rangwani",
        email: "harshrangwani.wk@gmail.com",
        domain: "Hunkaar",
        hash: "HNK021"
    },
    {
        name: "Yash jaiswal",
        email: "yashjaiswal490@gmail.com",
        domain: "Hunkaar",
        hash: "HNK022"
    },
    {
        name: "Mahika Pant",
        email: "mahikapant72@gmail.com",
        domain: "Hunkaar",
        hash: "HNK023"
    },
    {
        name: "Subhashit singh",
        email: "subhashit2510@gmail.com",
        domain: "Hunkaar",
        hash: "HNK024"
    },
    {
        name: "Akriti trivedi",
        email: "thisisakriti6559@gmail.com",
        domain: "Hunkaar",
        hash: "HNK025"
    },
    {
        name: "Mandeep Pathak",
        email: "themandeeppathak@gmail.com",
        domain: "Hunkaar",
        hash: "HNK026"
    },
    {
        name: "Harshita Jain",
        email: "jharshita1104@gmail.com",
        domain: "Hunkaar",
        hash: "HNK027"
    },
    {
        name: "Ritesh Kumar",
        email: "namansingh0471@gmail.com",
        domain: "Hunkaar",
        hash: "HNK028"
    },
    {
        name: "Harsh Raj Singh",
        email: "rajhars1990@gmail.com",
        domain: "Hunkaar",
        hash: "HNK029"
    },
    {
        name: "Anish Jaiswal",
        email: "ananyaanish4444@gmail.com",
        domain: "Hunkaar",
        hash: "HNK030"
    },
    {
        name: "Hardik Sehgal",
        email: "sehgalhardik00@gmail.com",
        domain: "Hunkaar",
        hash: "HNK031"
    },
    {
        name: "Kushagra Goel",
        email: "kushagra.goel@gmail.com",
        domain: "Hunkaar",
        hash: "HNK032"
    },
    {
        name: "Piyush Kumar",
        email: "7250piyushkumar@gmail.com",
        domain: "Hunkaar",
        hash: "HNK033"
    },
    {
        name: "Pragati Singh",
        email: "singhpragati5302@gmail.com",
        domain: "Hunkaar",
        hash: "HNK034"
    },
    {
        name: "Waruni Vijaya",
        email: "waruni.vijaya@gmail.com",
        domain: "Hunkaar",
        hash: "HNK035"
    },
    {
        name: "Raj Prakash",
        email: "Raj.prakash75@yahoo.com",
        domain: "Hunkaar",
        hash: "HNK036"
    },
    {
        name: "Sagun Koul",
        email: "sagunkoul1608@gmail.com",
        domain: "Hunkaar",
        hash: "HNK037"
    },
    {
        name: "Rushil Srivastava",
        email: "rushilrs2710@gmail.com",
        domain: "Hunkaar",
        hash: "HNK038"
    },
    {
        name: "Abhimat Tripathi",
        email: "randomusermennamegmail.com",
        domain: "Hunkaar",
        hash: "HNK039"
    }, {
        nam: "Rishika jain",
        email: "rishikajain1510@gmail.com",
        domain: "Hunkaar",
        hash: "HNK040"
    },
    {
        name: "Vaishnavi Borkar",
        email: "vmborkar1709@gmail.com",
        domain: "Hunkaar",
        hash: "HNK041"
    },
    {
        name: "Shivani",
        email: "shivanimishra12199@gmail.com",
        domain: "Hunkaar",
        hash: "HNK042"
    },
    {
        name: "Steve",
        email: "stevecjacob12@gmail.com",
        domain: "Hunkaar",
        hash: "HNK043"
    },
    {
        name: "Aalap",
        email: "kshirsagaraalap556@gmail.com",
        domain: "Hunkaar",
        hash: "HNK044"
    },
    {
        name: "Rihan",
        email: "rehanbhattacharyya8@gmail.com",
        domain: "Hunkaar",
        hash: "HNK045"
    },
    {
        name: "Arnold",
        email: "arnold.iype2005@gmail.com",
        domain: "Hunkaar",
        hash: "HNK046"
    },
    {
        name: "Aditi",
        email: "aditij233@gmail.com",
        domain: "Hunkaar",
        hash: "HNK047"
    },
    {
        name: "Shreyash",
        email: "shreyashchimurkar2014@gmail.com",
        domain: "Hunkaar",
        hash: "HNK048"
    },
    {
        name: "Karthik",
        email: "kartikson36@gmail.com",
        domain: "Hunkaar",
        hash: "HNK049"
    },
    {
        name: "Sania",
        email: "baniksania231@gmail.com",
        domain: "Hunkaar",
        hash: "HNK050"
    },
    {
        name: "Harsh Parmar",
        email: "harshparmar142hp2@gmail.com",
        domain: "Show it Down",
        hash: "SID001"
    },
    {
        name: "Vinay Badwal",
        email: "harshparmar142hp2@gmail.com",
        domain: "Show it Down",
        hash: "SID002"
    },
    {
        name: "Harsh Chouhan",
        email: "harshparmar142hp2@gmail.com",
        domain: "Show it Down",
        hash: "SID003"
    },
    {
        name: "Disha Khatri",
        email: "harshparmar142hp2@gmail.com",
        domain: "Show it Down",
        hash: "SID004"
    },
    {
        name: "Priya Sharma",
        email: "harshparmar142hp2@gmail.com",
        domain: "Show it Down",
        hash: "SID005"
    },
    {
        name: "Chetan Panchal",
        email: "harshparmar142hp2@gmail.com",
        domain: "Show it Down",
        hash: "SID006"
    },
    {
        name: "Yash Lajwanshi",
        email: "harshparmar142hp2@gmail.com",
        domain: "Show it Down",
        hash: "SID007"
    },
    {
        name: "Aditi Diwan",
        email: "aditidiwan2506@gmail.com",
        domain: "Show it Down",
        hash: "SID008"
    },
    {
        name: "Anirudh Soni",
        email: "aditidiwan2506@gmail.com",
        domain: "Show it Down",
        hash: "SID009"
    },
    {
        name: "Kartik Silodiya",
        email: "aditidiwan2506@gmail.com",
        domain: "Show it Down",
        hash: "SID010"
    },
    {
        name: "Rishibha Jain",
        email: "aditidiwan2506@gmail.com",
        domain: "Show it Down",
        hash: "SID011"
    },
    {
        name: "Deeshank Batra",
        email: "aditidiwan2506@gmail.com",
        domain: "Show it Down",
        hash: "SID012"
    },
    {
        name: "Manvi Draboo",
        email: "aditidiwan2506@gmail.com",
        domain: "Show it Down",
        hash: "SID013"
    },
    {
        name: "Vaishnavee Aheer",
        email: "aditidiwan2506@gmail.com",
        domain: "Show it Down",
        hash: "SID014"
    },
    {
        name: "Sujal Bhati",
        email: "aditidiwan2506@gmail.com",
        domain: "Show it Down",
        hash: "SID015"
    },
    {
        name: "Ajit Singh Dhurve",
        email: "aditidiwan2506@gmail.com",
        domain: "Show it Down",
        hash: "SID016"
    },
    {
        name: "Yashika Chouhan",
        email: "aditidiwan2506@gmail.com",
        domain: "Show it Down",
        hash: "SID017"
    },
    {
        name: "Diksha Bhawsar",
        email: "dbhawsar718@gmail.com",
        domain: "Show it Down",
        hash: "SID018"
    },
    {
        name: "Aditya Pandey",
        email: "dbhawsar718@gmail.com",
        domain: "Show it Down",
        hash: "SID019"
    },
    {
        name: "Hardik Yadav",
        email: "dbhawsar718@gmail.com",
        domain: "Show it Down",
        hash: "SID020"
    },
    {
        name: "Akshi Dhurve",
        email: "dbhawsar718@gmail.com",
        domain: "Show it Down",
        hash: "SID021"
    },
    {
        name: "Hitarth Tilak",
        email: "dbhawsar718@gmail.com",
        domain: "Show it Down",
        hash: "SID022"
    },
    {
        name: "Chiranjeev Matkar",
        email: "dbhawsar718@gmail.com",
        domain: "Show it Down",
        hash: "SID023"
    },
    {
        name: "Shreya Vagare",
        email: "dbhawsar718@gmail.com",
        domain: "Show it Down",
        hash: "SID024"
    },
    {
        name: "Harshit Soni",
        email: "dbhawsar718@gmail.com",
        domain: "Show it Down",
        hash: "SID025"
    },
    {
        name: "Tanishq Bilarwan",
        email: "dbhawsar718@gmail.com",
        domain: "Show it Down",
        hash: "SID026"
    },
    {
        name: "Vaishnavi Rajput",
        email: "dbhawsar718@gmail.com",
        domain: "Show it Down",
        hash: "SID027"
    },
    {
        name: "Jayesh amode",
        email: "dbhawsar718@gmail.com",
        domain: "Show it Down",
        hash: "SID028"
    },
    {
        name: "Anuj Maheshram",
        email: "dbhawsar718@gmail.com",
        domain: "Show it Down",
        hash: "SID029"
    },
    {
        name: "Astitva Bhate",
        email: "dbhawsar718@gmail.com",
        domain: "Show it Down",
        hash: "SID030"
    },
    {
        name: "Chinmay Kunhare",
        email: "dbhawsar718@gmail.com",
        domain: "Show it Down",
        hash: "SID031"
    },
    {
        name: "Aditi parteti",
        email: "dbhawsar718@gmail.com",
        domain: "Show it Down",
        hash: "SID032"
    },
    {
        name: "Satwik Nayak",
        email: "socialsatwik@gmail.com",
        domain: "Show it Down",
        hash: "SID033"
    },
    {
        name: "Vibhuti Purohit",
        email: "socialsatwik@gmail.com",
        domain: "Show it Down",
        hash: "SID034"
    },
    {
        name: "Shefali Dewangan",
        email: "socialsatwik@gmail.com",
        domain: "Show it Down",
        hash: "SID035"
    },
    {
        name: "Aditya Gupta",
        email: "socialsatwik@gmail.com",
        domain: "Show it Down",
        hash: "SID036"
    },
    {
        name: "Manas Maheshwari",
        email: "socialsatwik@gmail.com",
        domain: "Show it Down",
        hash: "SID037"
    },
    {
        name: "Palak Soni",
        email: "socialsatwik@gmail.com",
        domain: "Show it Down",
        hash: "SID038"
    },
    {
        name: "Ashmi Jain",
        email: "socialsatwik@gmail.com",
        domain: "Show it Down",
        hash: "SID039"
    },
    {
        name: "Tushita Gakkhar",
        email: "socialsatwik@gmail.com",
        domain: "Show it Down",
        hash: "SID040"
    },
    {
        name: "Yash Soni",
        email: "socialsatwik@gmail.com",
        domain: "Show it Down",
        hash: "SID041"
    },
    {
        name: "Atharva Ved Rai",
        email: "socialsatwik@gmail.com",
        domain: "Show it Down",
        hash: "SID042"
    },
    {
        name: "Abhishek sharma",
        email: "abhisheksharma.dx20@acropolis.in",
        domain: "Show it Down",
        hash: "SID043"
    },
    {
        name: "Parth Vyas",
        email: "abhisheksharma.dx20@acropolis.in",
        domain: "Show it Down",
        hash: "SID044"
    },
    {
        name: "Urvashi Pathak",
        email: "abhisheksharma.dx20@acropolis.in",
        domain: "Show it Down",
        hash: "SID045"
    },
    {
        name: "Shruti Intodiya",
        email: "abhisheksharma.dx20@acropolis.in",
        domain: "Show it Down",
        hash: "SID046"
    },
    {
        name: "Tanishqa Bandi",
        email: "abhisheksharma.dx20@acropolis.in",
        domain: "Show it Down",
        hash: "SID047"
    },
    {
        name: "Tisha Dhamu",
        email: "abhisheksharma.dx20@acropolis.in",
        domain: "Show it Down",
        hash: "SID048"
    },
    {
        name: "Bhavik Sharma",
        email: "abhisheksharma.dx20@acropolis.in",
        domain: "Show it Down",
        hash: "SID049"
    },
    {
        name: "Aojasvi Sharma",
        email: "abhisheksharma.dx20@acropolis.in",
        domain: "Show it Down",
        hash: "SID050"
    },
    {
        name: "Kunal Rathod",
        email: "abhisheksharma.dx20@acropolis.in",
        domain: "Show it Down",
        hash: "SID051"
    },
    {
        name: "Charu Pancholi",
        email: "abhisheksharma.dx20@acropolis.in",
        domain: "Show it Down",
        hash: "SID052"
    },
    {
        name: "Vedant Somani",
        email: "abhisheksharma.dx20@acropolis.in",
        domain: "Show it Down",
        hash: "SID053"
    },
    {
        name: "Priyanshi Karamchandani",
        email: "abhisheksharma.dx20@acropolis.in",
        domain: "Show it Down",
        hash: "SID054"
    },
    {
        name: "Khushboo kolte",
        email: "abhisheksharma.dx20@acropolis.in",
        domain: "Show it Down",
        hash: "SID055"
    },
    {
        name: "Pratishta Holkar",
        email: "abhisheksharma.dx20@acropolis.in",
        domain: "Show it Down",
        hash: "SID056"
    },
    {
        name: "Garima Nagdeve",
        email: "abhisheksharma.dx20@acropolis.in",
        domain: "Show it Down",
        hash: "SID057"
    },
    {
        name: "Senthilkumar Shreyaa",
        email: "i20senthilkumars@iimidr.ac.in",
        domain: "Show it Down",
        hash: "SID058"
    },
    {
        name: "Vrinda PV",
        email: "i20senthilkumars@iimidr.ac.in",
        domain: "Show it Down",
        hash: "SID059"
    },
    {
        name: "Suhani Yadav",
        email: "i20senthilkumars@iimidr.ac.in",
        domain: "Show it Down",
        hash: "SID060"
    },
    {
        name: "Bhoomika Agrawal",
        email: "i20senthilkumars@iimidr.ac.in",
        domain: "Show it Down",
        hash: "SID061"
    },
    {
        name: "Harsh Raj",
        email: "i20senthilkumars@iimidr.ac.in",
        domain: "Show it Down",
        hash: "SID062"
    },
    {
        name: "Aviral Raj Jain",
        email: "i20senthilkumars@iimidr.ac.in",
        domain: "Show it Down",
        hash: "SID063"
    },
    {
        name: "Anvita Jerai",
        email: "i20senthilkumars@iimidr.ac.in",
        domain: "Show it Down",
        hash: "SID064"
    },
    {
        name: "Sanskar Maheshwari",
        email: "i20senthilkumars@iimidr.ac.in",
        domain: "Show it Down",
        hash: "SID065"
    },
    {
        name: "Plaksha Agrawal",
        email: "i20senthilkumars@iimidr.ac.in",
        domain: "Show it Down",
        hash: "SID066"
    },
    {
        name: "shivam mishra",
        email: "sm1522164@gmail.com",
        domain: "Show it Down",
        hash: "SID067"
    },
    {
        name: "deepak",
        email: "sm1522164@gmail.com",
        domain: "Show it Down",
        hash: "SID068"
    },
    {
        name: "rahul",
        email: "sm1522164@gmail.com",
        domain: "Show it Down",
        hash: "SID069"
    },
    {
        name: "kamlesh",
        email: "sm1522164@gmail.com",
        domain: "Show it Down",
        hash: "SID070"
    },
    {
        name: "vinod",
        email: "sm1522164@gmail.com",
        domain: "Show it Down",
        hash: "SID071"
    },
    {
        name: "mukul",
        email: "sm1522164@gmail.com",
        domain: "Show it Down",
        hash: "SID072"
    },
    {
        name: "Atharv vyas",
        email: "Atharvvyas12@gmail.com",
        domain: "Show it Down",
        hash: "SID073"
    },
    {
        name: "Arjun mehar",
        email: "Atharvvyas12@gmail.com",
        domain: "Show it Down",
        hash: "SID074"
    },
    {
        name: "Vedansh",
        email: "Atharvvyas12@gmail.com",
        domain: "Show it Down",
        hash: "SID075"
    },
    {
        name: "Vivek raghuwanshi",
        email: "Atharvvyas12@gmail.com",
        domain: "Show it Down",
        hash: "SID076"
    },
    {
        name: "Prince Rai",
        email: "Atharvvyas12@gmail.com",
        domain: "Show it Down",
        hash: "SID077"
    },
    {
        name: "Rohit",
        email: "Atharvvyas12@gmail.com",
        domain: "Show it Down",
        hash: "SID078"
    },
    {
        name: "Nikhil Agrawal",
        email: "Nagrawal1901@gmail.com",
        domain: "On the Beat",
        hash: "OTB001"
    },
    {
        name: "KONPAL RAKHONDE",
        email: "arakhonde1@gmail.com",
        domain: "On the Beat",
        hash: "OTB002"
    },
    {
        name: "DIVI GUPTA",
        email: "guptadivi267@gmail.com",
        domain: "On the Beat",
        hash: "OTB003"
    },
    {
        name: "Khushi Yadav",
        email: "khyyadav704@gmail.com",
        domain: "On the Beat",
        hash: "OTB004"
    },
    {
        name: "Smarani Basu",
        email: "smarani.basu2020@vitbhopal.ac.in",
        domain: "On the Beat",
        hash: "OTB005"
    },
    {
        name: "Sahaj ved",
        email: "sahajved16@gmail.com",
        domain: "On the Beat",
        hash: "OTB006"
    },
    {
        name: "Mohit kumar Tantway",
        email: "mohittantway1234@gmail.com",
        domain: "On the Beat",
        hash: "OTB007"
    },
    {
        name: "Rishi Bakadiya",
        email: "rishibakadiya96@gmail.com",
        domain: "On the Beat",
        hash: "OTB008"
    },
    {
        name: "Vineet Shirvastava",
        email: "vineetshri2003@gmail.com",
        domain: "On the Beat",
        hash: "OTB009"
    },
    {
        name: "kunal Lokhande",
        email: "kunallokhande050@email.com",
        domain: "On the Beat",
        hash: "OTB010"
    },
    {
        name: "Ashley lamaniya",
        email: "ashleylamaniya@gmail.com",
        domain: "On the Beat",
        hash: "OTB011"
    },
    {
        name: "Aditya Singh Jayant",
        email: "adityajayant799@gmail.com",
        domain: "On the Beat",
        hash: "OTB012"
    },
    {
        name: "Khushi Harbas",
        email: "khushiharbas14@gmail.com",
        domain: "On the Beat",
        hash: "OTB013"
    },
    {
        name: "Vishal Shukla ( DEMON )",
        email: "vishalshuklademon@gmail.com",
        domain: "On the Beat",
        hash: "OTB014"
    },
    {
        name: "Swanand Girrey",
        email: "swanand.girrey14@gmail.com",
        domain: "On the Beat",
        hash: "OTB015"
    },
    {
        name: "Ritika tak",
        email: "ritika29122000@gmail.com",
        domain: "On the Beat",
        hash: "OTB016"
    },
    {
        name: "Jayni Trivedi",
        email: "jaynitrivedi7@gmail.com",
        domain: "On the Beat",
        hash: "OTB017"
    },
    {
        name: "Mahima Tiwari",
        email: "tmahima547@gmail.com",
        domain: "On the Beat",
        hash: "OTB018"
    },
    {
        name: "Sneha Negi",
        email: "snehanegi90019@gmail.com",
        domain: "On the Beat",
        hash: "OTB019"
    },
    {
        name: "Darsh Dunsuaa",
        email: "darshsunsuaa@gmail.com",
        domain: "On the Beat",
        hash: "OTB020"
    },
    {
        name: "Anjali Adroit",
        email: "ce190004018@iiti.ac.in",
        domain: "On the Beat",
        hash: "OTB021"
    },
    {
        name: "Ishani Goswami",
        email: "ishani.goswami2020@vitbhopal.ac.in",
        domain: "On the Beat",
        hash: "OTB022"
    },
    {
        name: "Shubhangi Chouhan",
        email: "ydmkid13@gmail.com",
        domain: "On the Beat",
        hash: "OTB023"
    },
    {
        name: "Khushi Agarwal",
        email: "cse210001028@iiti.ac.in",
        domain: "On the Beat",
        hash: "OTB024"
    },
    {
        name: "Akshi Dhurve",
        email: "akshidhurve3@gmail.com",
        domain: "On the Beat",
        hash: "OTB025"
    },
    {
        name: "Vinod sharma",
        email: "vinod.234@icloud.com",
        domain: "On the Beat",
        hash: "OTB026"
    },
    {
        name: "Diksha Bhawsar",
        email: "dbhawsar718@gmail.com",
        domain: "On the Beat",
        hash: "OTB027"
    },
    {
        name: "Shreya Vagare",
        email: "shreyavagare09@gmail.com",
        domain: "On the Beat",
        hash: "OTB028"
    },
    {
        name: "Megha Kumaran",
        email: "i22meghak@iimidr.ac.in",
        domain: "On the Beat",
        hash: "OTB029"
    },
    {
        name: "Krishna Dubey",
        email: "kushkrishna2016@gmail.com",
        domain: "On the Beat",
        hash: "OTB030"
    },
    {
        name: "Anshika Patwari",
        email: "anshika.patwari04@gmail.com",
        domain: "On the Beat",
        hash: "OTB031"
    },
    {
        name: "NX and THAPA",
        email: "guptadivi267@gmail.com",
        domain: "On the Beat",
        hash: "OTB032"
    },
    {
        name: "Shubhra Gite",
        email: "shubhra1306gite@gmail.com",
        domain: "On the Beat",
        hash: "OTB033"
    },
    {
        name: "Swanand Girrey",
        email: "swanand.girrey14@gmail.com",
        domain: "On the Beat",
        hash: "OTB034"
    },
    {
        name: "Himanshu bansal",
        email: "Harrysailor21@gmail.com",
        domain: "Mono Acting",
        hash: "MA001"
    },
    {
        name: "Palash Pathak",
        email: "palashpathakpp.90.18@gamil.com",
        domain: "Mono Acting",
        hash: "MA002"
    },
    {
        name: "Shubhra Gite",
        email: "shubhra1306gite@gmail.com",
        domain: "Mono Acting",
        hash: "MA003"
    },
    {
        name: "Aman Kumar",
        email: "amankumar2022@vitbhopal.ac.in",
        domain: "Mono Acting",
        hash: "MA004"
    },
    {
        name: "Kavya Dichwalkar",
        email: "kavyadichwalkar2022@vitbhopal.ac.in",
        domain: "Mono Acting",
        hash: "MA005"
    },
    {
        name: "Avni Seem",
        email: "avniseem2022@vitbhopal.ac.in",
        domain: "Mono Acting",
        hash: "MA006"
    },
    {
        name: "Aditi Srivastava",
        email: "aditisrivastava2022@vitbhopal.ac.in",
        domain: "Mono Acting",
        hash: "MA007"
    },
    {
        name: "Tarun Soni",
        email: "taruniiti.21@gmail.com",
        domain: "Mono Acting",
        hash: "MA008"
    },
    {
        name: "Yash Chandramore",
        email: "yashchandramore2@gmail.com",
        domain: "Mono Acting",
        hash: "MA009"
    },
    {
        name: "Kanak Goyal",
        email: "newkaveiw@gmail.com",
        domain: "Mono Acting",
        hash: "MA010"
    },
    {
        name: "Shashank Chaturvedi",
        email: "shashankchaturvedi154@gmail.com",
        domain: "Through the Lens",
        hash: "TTL001"
    },
    {
        name: "Samridhi Dubey",
        email: "samridhi.dubey2020@vitbhopal.ac.in",
        domain: "Through the Lens",
        hash: "TTL002"
    },
    {
        name: "Harshil Rathod",
        email: "rathod.harshil2020@vitbhopal.ac.in",
        domain: "Through the Lens",
        hash: "TTL003"
    },
    {
        name: "Parul Chouhan",
        email: "parulchouhan121@gmail.com",
        domain: "Through the Lens",
        hash: "TTL004"
    },
    {
        name: "Atharav Bhawsar",
        email: "atharavbhawsar06@gmail.com",
        domain: "Through the Lens",
        hash: "TTL005"
    },
    {
        name: "Mor Vrushabh Bharatbhai",
        email: "vrushabhmor27@gmail.com",
        domain: "Through the Lens",
        hash: "TTL006"
    },
    {
        name: "Hemant Kumar",
        email: "hemaannk07@gmail.com",
        domain: "Through the Lens",
        hash: "TTL007"
    },
    {
        name: "Vikas Maurya",
        email: "vikasmaurya.alld.164@gmail.com",
        domain: "Through the Lens",
        hash: "TTL008"
    },
    {
        name: "Chirag Gour",
        email: "chiraggour2002@gmail.com",
        domain: "Through the Lens",
        hash: "TTL009"
    },
    {
        name: "Vishal Kumar",
        email: "ee210002083@iiti.ac.in",
        domain: "Through the Lens",
        hash: "TTL010"
    },
    {
        name: "Pawan Nishad",
        email: "nishadpawan119@gmail.com",
        domain: "Live Sketching",
        hash: "LS001"
    },
    {
        name: "Umesh Jaiswal",
        email: "theumeshjaiswal@gmail.com",
        domain: "Live Sketching",
        hash: "LS002"
    },
    {
        name: "sakshi pachlaniya",
        email: "sakshipachlaniya@gmail.com",
        domain: "Live Sketching",
        hash: "LS003"
    },
    {
        name: "Akshita Gandhi",
        email: "akshitagandhi02@gmail.com",
        domain: "Live Sketching",
        hash: "LS004"
    },
    {
        name: "Rajesh Parmar",
        email: "parmarrajesh772@gmail.com",
        domain: "Live Sketching",
        hash: "LS005"
    },
    {
        name: "Tushar Dharam",
        email: "Tushardharam098@gmail.com",
        domain: "Live Sketching",
        hash: "LS006"
    },
    {
        name: "Khushal Dabhade",
        email: "khushalkd73844@gmail.com",
        domain: "Live Sketching",
        hash: "LS007"
    },
    {
        name: "Uday Jaiswal",
        email: "theudayjaiswal@gmail.com",
        domain: "Live Sketching",
        hash: "LS008"
    },
    {
        name: "Rakhi Sen",
        email: "rakhisen210491@acropolis.in",
        domain: "Live Sketching",
        hash: "LS009"
    },
    {
        name: "Bhupesh Kumar",
        email: "me200003021@iiti.ac.in",
        domain: "Live Sketching",
        hash: "LS010"
    },
    {
        name: "Mayank Ramnani",
        email: "phd2201101004@iiti.ac.in",
        domain: "Live Sketching",
        hash: "LS011"
    },
    {
        name: "Madhurima Das",
        email: "msc2203141009@iiti.ac.in",
        domain: "Live Sketching",
        hash: "LS012"
    },
    {
        name: "Avani Ravindra Wanjari",
        email: "me210003020@iiti.ac.in",
        domain: "Live Sketching",
        hash: "LS013"
    },
    {
        name: "Somya Sanchoriya",
        email: "sanchoriya4321@gmail.com",
        domain: "Stand Up",
        hash: "STU001"
    },
    {
        name: "Daksh marnat",
        email: "dakshmarmat10@gmail.com",
        domain: "Stand Up",
        hash: "STU002"
    },
    {
        name: "Mihir Naik",
        email: "mihirnaik.0412@gmail.com",
        domain: "Stand Up",
        hash: "STU003"
    },
    {
        name: "Tarun Soni",
        email: "taruniiti.21@gmail.com",
        domain: "Stand Up",
        hash: "STU004"
    },
    {
        name: "Rajarshi pathak",
        email: "rajarshipathak482001@gmail.com",
        domain: "Stand Up",
        hash: "STU005"
    },
    {
        name: "Vikas Maurya",
        email: "vikasmaurya.alld.164@gmail.com",
        domain: "Stand Up",
        hash: "STU006"
    },
    {
        name: "Subhash Yadav",
        email: "subhash.bohemia78@gmail.com",
        domain: "Stand Up",
        hash: "STU007"
    },
    {
        name: "Saurabh yadav",
        email: "Saurabh.yadav1201@gmail.com",
        domain: "Stand Up",
        hash: "STU008"
    },
    {
        name: "Amardeep Padalwar",
        email: "padalwaramardeep@gmail.com",
        domain: "Stand Up",
        hash: "STU009"
    },
    {
        name: "Prakhar Keshari",
        email: "prakharkeshari7@gmail.com",
        domain: "Stand Up",
        hash: "STU010"
    },
    {
        name: "Shivam Shukla",
        email: "shivamshuklag7@gmail.com",
        domain: "Stand Up",
        hash: "STU011"
    },
    {
        name: "Raghav Taparia",
        email: "raghav204taparia@gmail.com",
        domain: "Stand Up",
        hash: "STU012"
    },
    {
        name: "Abhay Jadhav",
        email: "almostabhay@gmail.com",
        domain: "Stand Up",
        hash: "STU013"
    },
    {
        name: "Siddharth Kheroniya",
        email: "siddharthkheroniya@gmail.com",
        domain: "Mehfil",
        hash: "MHF001"
    },
    {
        name: "Abhijeet Rajoriya",
        email: "abhijeetrajoriya8055@gmail.com",
        domain: "Mehfil",
        hash: "MHF002"
    },
    {
        name: "Shreya Jain",
        email: "jainshreya9802@gmail.com",
        domain: "Mehfil",
        hash: "MHF003"
    },
    {
        name: "Ujjawal kumar jha",
        email: "ujjawal10854@gmail.com",
        domain: "Mehfil",
        hash: "MHF004"
    },
    {
        name: "Nadeem Khan",
        email: "nadeemkhan24762@gmail.com",
        domain: "Mehfil",
        hash: "MHF005"
    },
    {
        name: "Ansh Chopra",
        email: "msc2103121002@iiti.ac.in",
        domain: "Mehfil",
        hash: "MHF006"
    },
    {
        name: "Ashad Ahmad",
        email: "msc2203121010@iiti.ac.in",
        domain: "Mehfil",
        hash: "MHF007"
    },
    {
        name: "Prakhar Keshari",
        email: "mt2202102010@iiti.ac.in",
        domain: "Mehfil",
        hash: "MHF008"
    },
    {
        name: "Vinayak Kaushal",
        email: "vinayakkaushal747@gmail.com",
        domain: "Mehfil",
        hash: "MHF009"
    },
    {
        name: "Vishal Chichani",
        email: "ee200002080@iiti.ac.in",
        domain: "Mehfil",
        hash: "MHF010"
    },
    {
        name: "Anjali Pandey",
        email: "anjalipandey1333@gmail.com",
        domain: "Mehfil",
        hash: "MHF011"
    },
    {
        name: "Priyank Bhadouriya",
        email: "bhadouriyapriyank7@gmail.com",
        domain: "Mehfil",
        hash: "MHF012"
    },
    {
        name: "Aparajita Dixit",
        email: "aparajitadixit47@gmail.com",
        domain: "Mehfil",
        hash: "MHF013"
    },
    {
        name: "Aditya Agrawal",
        email: "adit456agrawal@gmail.com",
        domain: "Mehfil",
        hash: "MHF014"
    },
    {
        name: "Mihir Naik",
        email: "mihirnaik.0412@gmail.com",
        domain: "Mehfil",
        hash: "MHF015"
    },
    {
        name: "Harshwardhan Chaube",
        email: "ee200002039@iiti.ac.in",
        domain: "Mehfil",
        hash: "MHF016"
    },
    {
        name: "Anmol Rathore",
        email: "anmolrathor1234@gmail.com",
        domain: "Mehfil",
        hash: "MHF017"
    },
    {
        name: "Harish Sahu",
        email: "phd2001261002@iiti.ac.in",
        domain: "Mehfil",
        hash: "MHF018"
    },
    {
        name: "Dilip Kumar Mishra",
        email: "lekhaksandesh@gmail.com",
        domain: "Mehfil",
        hash: "MHF019"
    },
    {
        name: "Anil Ahirwar",
        email: "anilahirwar2020@gmail.com",
        domain: "Mehfil",
        hash: "MHF020"
    },
    {
        name: "Devpreet",
        email: "devbhawsar2001@gmail.com",
        domain: "Mehfil",
        hash: "MHF021"
    },
    {
        name: "Atharva Shrivastava",
        email: "atharvashrivastava327@gmail.com",
        domain: "Mehfil",
        hash: "MHF022"
    },
    {
        name: "Harshwardhan Tripathi",
        email: "harshavardhantripathi210037@acropolis.in",
        domain: "Mehfil",
        hash: "MHF023"
    },
    {
        name: "Mritika Mazumder",
        email: "Kri.timo12@gmail.com",
        domain: "Mehfil",
        hash: "MHF024"
    },
    {
        name: "Ansh Chopra",
        email: "msc2103121002@iiti.ac.in",
        domain: "Mehfil",
        hash: "MHF025"
    },
    {
        name: "Sumantra Aarya",
        email: "mt2102103012@iiti.ac.in",
        domain: "Mehfil",
        hash: "MHF026"
    },
    {
        name: "Mradul Patoria",
        email: "mradulpatoria9703@gmail.com",
        domain: "Mehfil",
        hash: "MHF027"
    },
    {
        name: "Gajesh Sharma",
        email: "gajeshkumar00@gmail.com",
        domain: "Mehfil",
        hash: "MHF028"
    },
    {
        name: "Vatsalya Singh",
        email: "ee220002080@iiti.ac.in",
        domain: "Mehfil",
        hash: "MHF029"
    },
    {
        name: "Satvik Desai",
        email: "ee220002074@iiti.ac.in",
        domain: "Mehfil",
        hash: "MHF030"
    },
    {
        name: "Shivankar Sharma",
        email: "ee210002071@iiti.ac.in",
        domain: "Mehfil",
        hash: "MHF031"
    },
    {
        name: "Jeetesh Patel",
        email: "ce210004019@iiti.ac.in",
        domain: "Mehfil",
        hash: "MHF032"
    },
    {
        name: "Raina Tathed",
        email: "ee220002067@iiti.ac.in",
        domain: "Mehfil",
        hash: "MHF033"
    },
    {
        name: "Rohit Narwariya",
        email: "narwariyarohit012@gamil.com",
        domain: "Doodle Up",
        hash: "DDU001"
    },
    {
        name: "Nishi Thakur",
        email: "03nishithakur@gmail.com",
        domain: "Doodle Up",
        hash: "DDU002"
    },
    {
        name: "Mayank Ramnani",
        email: "phd2201101004@iiti.ac.in",
        domain: "Doodle Up",
        hash: "DDU003"
    },
    {
        name: "Akshita Adhikari",
        email: "akshita.adhikari2020@vitbhopal.ac.in",
        domain: "Elegancia",
        hash: "ELG001"
    },
    {
        name: "Medha Verma",
        email: "vmedha51@gmail.com",
        domain: "Elegancia",
        hash: "ELG002"
    },
    {
        name: "Sweta Kumari",
        email: "swetakumari969389@gmail.com",
        domain: "Elegancia",
        hash: "ELG003"
    },
    {
        name: "Soundarya Dube",
        email: "Soundaryadube2022@vitbhopal.ac.in",
        domain: "Elegancia",
        hash: "ELG004"
    },
    {
        name: "Khushi Agrawal",
        email: "cse210001028@iiti.ac.in",
        domain: "Elegancia",
        hash: "ELG005"
    },
    {
        name: "Ritika Soudagar",
        email: "ritikasodagar@gmail.com",
        domain: "Elegancia",
        hash: "ELG006"
    },
    {
        name: "Vinit Jadav",
        email: "vinitjadhav2533@gmail.com",
        domain: "Elegancia",
        hash: "ELG007"
    },
    {
        name: "Sheetal Gehani",
        email: "Sheetalgehani148@gmail.com",
        domain: "Elegancia",
        hash: "ELG008"
    },
    {
        name: "Neha Sahay",
        email: "xepelint@gmail.com",
        domain: "Elegancia",
        hash: "ELG009"
    },
    {
        name: "Rakshita Jain",
        email: "rakshitajain1122@gmail.com",
        domain: "Elegancia",
        hash: "ELG010"
    },
    {
        name: "Aditya  Shinde",
        email: "adityac1909@gmail.com",
        domain: "Shutter Up",
        hash: "SHU001"
    },
    {
        name: "Jesmal Jalal",
        email: "jesmalj@gmail.com",
        domain: "Shutter Up",
        hash: "SHU002"
    },
    {
        name: "Shrey Shah",
        email: "shreyshah0512@gmail.com",
        domain: "Shutter Up",
        hash: "SHU003"
    },
    {
        name: "Prasan Kapoor",
        email: "kapoorprasan1997@gmail.com",
        domain: "Shutter Up",
        hash: "SHU004"
    },
    {
        name: "Antima Mukati",
        email: "mukatiantima@gmail.com",
        domain: "Shutter Up",
        hash: "SHU005"
    },
    {
        name: "Debapriyo Karmakar",
        email: "debapriyokarmakar08@gmail.com",
        domain: "Shutter Up",
        hash: "SHU006"
    },
    {
        name: "Chirag Kedia",
        email: "chiragkedia2@gmail.com",
        domain: "Shutter Up",
        hash: "SHU007"
    },
    {
        name: "DEBRAJ ROY",
        email: "roydrone8@gmail.com",
        domain: "Shutter Up",
        hash: "SHU008"
    },
    {
        name: "Parth Lahoti",
        email: "parth.lahoti.sjc1950@shishukunj.in",
        domain: "Shutter Up",
        hash: "SHU009"
    },
    {
        name: "Ritik Singh Chauhan",
        email: "ritik.2024me1071@kiet.edu",
        domain: "Shutter Up",
        hash: "SHU010"
    },
    {
        name: "Siddhant Kumar",
        email: "200030054@iitdh.ac.in",
        domain: "Shutter Up",
        hash: "SHU011"
    },
    {
        name: "Jassan Sanjay",
        email: "sanjayyy424@gmail.com",
        domain: "Shutter Up",
        hash: "SHU012"
    },
    {
        name: "Abhinav Sharma",
        email: "abhinav22@manageites.org",
        domain: "Shutter Up",
        hash: "SHU013"
    },
    {
        name: "Nitheesh A",
        email: "Nitheesh0711@gmail.com",
        domain: "Shutter Up",
        hash: "SHU014"
    },
    {
        name: "Siddharth Jangra",
        email: "siddharthjangra47@gmail.com",
        domain: "Shutter Up",
        hash: "SHU015"
    },
    {
        name: "AMAN AGRAHARI",
        email: "amanspammessage@gmail.com",
        domain: "Shutter Up",
        hash: "SHU016"
    },
    {
        name: "Gunaseelan S",
        email: "seelanguna5916@gmail.com",
        domain: "Shutter Up",
        hash: "SHU017"
    },
    {
        name: "Didarul Mazumder",
        email: "didarul8915@gmail.com",
        domain: "Shutter Up",
        hash: "SHU018"
    },
    {
        name: "Dushyant Rahangdale",
        email: "mms2022_146iom@met.edu",
        domain: "Shutter Up",
        hash: "SHU019"
    },
    {
        name: "Akshay P Raj",
        email: "21021141015@sibmhyd.edu.in",
        domain: "Shutter Up",
        hash: "SHU020"
    },
    {
        name: "Mallemala Sai Teja",
        email: "saiteja.mallemala7.iitkgp@gmail.com",
        domain: "Shutter Up",
        hash: "SHU021"
    },
    {
        name: "Fareedahmed betageri",
        email: "fareedahmedbetageri208@gmail.com",
        domain: "Shutter Up",
        hash: "SHU022"
    },
    {
        name: "Dhaval Shah",
        email: "dhavals2912@gmail.com",
        domain: "Shutter Up",
        hash: "SHU023"
    },
    {
        name: "Navya Sinha",
        email: "navyasinha111@gmail.com",
        domain: "Shutter Up",
        hash: "SHU024"
    },
    {
        name: "Vishmay Gupta",
        email: "vismaysc@gmail.com",
        domain: "Shutter Up",
        hash: "SHU025"
    },
    {
        name: "THALE PREM SAJJAN",
        email: "thaleprem19@gmail.com",
        domain: "Shutter Up",
        hash: "SHU026"
    },
    {
        name: "Niharika Nimesh",
        email: "niharika.nimesh21@iimranchi.ac.in",
        domain: "Shutter Up",
        hash: "SHU027"
    },
    {
        name: "ARKAPRABHA MANDAL",
        email: "arkaprabhamandal547@gmail.com",
        domain: "Shutter Up",
        hash: "SHU028"
    },
    {
        name: "Harsh Srivastava",
        email: "srivastavaharsh865@gmail.com",
        domain: "Shutter Up",
        hash: "SHU029"
    },
    {
        name: "Karan Singare",
        email: "kanny131103@gmail.com",
        domain: "Shutter Up",
        hash: "SHU030"
    },
    {
        name: "Bhavna",
        email: "r875129@gmail.com",
        domain: "Shutter Up",
        hash: "SHU031"
    },
    {
        name: "Arkaprabha Mandal",
        email: "arkaprabhamandal547@gmail.com",
        domain: "Shutter Up",
        hash: "SHU032"
    },
    {
        name: "Anuron Mullik",
        email: "anuron.mullik@gmail.com",
        domain: "Shutter Up",
        hash: "SHU033"
    },
    {
        name: "Suvankar Das",
        email: "suvankardas207@gmail.com",
        domain: "Shutter Up",
        hash: "SHU034"
    },
    {
        name: "Aadarsh K",
        email: "aadarshkannan111@gmail.com",
        domain: "Shutter Up",
        hash: "SHU035"
    },
    {
        name: "Shreyas Kotambri",
        email: "shreyaskotambri@gmail.com",
        domain: "Shutter Up",
        hash: "SHU036"
    },
    {
        name: "Insha Shahnawaz",
        email: "worldinez@gmail.com",
        domain: "Shutter Up",
        hash: "SHU037"
    },
    {
        name: "Raj",
        email: "rajbarad711997@gmail.com",
        domain: "Shutter Up",
        hash: "SHU038"
    },
    {
        name: "Himanshu Patle",
        email: "himanshupatle78@gmail.co",
        domain: "Shutter Up",
        hash: "SHU039"
    },
    {
        name: "Chayan Das",
        email: "chayandaschayan@gmail.com",
        domain: "Shutter Up",
        hash: "SHU040"
    },
    {
        name: "Parth Shah",
        email: "dasalman35@gmail.com",
        domain: "Shutter Up",
        hash: "SHU041"
    },
    {
        name: "Harsh Mandloi",
        email: "harshmandloi3@gmail.com",
        domain: "3D Render Challenge",
        hash: "3DR001"
    },
    {
        name: "Harshvardhan Singh Rathod",
        email: "harshvardhan2818@gmail.com",
        domain: "3D Render Challenge",
        hash: "3DR002"
    },
    {
        name: "Yash Baghel",
        email: "ee220002083@iiti.ac.in",
        domain: "3D Render Challenge",
        hash: "3DR003"
    },
    {
        name: "Saurabh Kundalwal",
        email: "Kundalwalsaurabh56@gmail.com",
        domain: "3D Render Challenge",
        hash: "3DR004"
    },
    {
        name: "Aruna Choudhary",
        email: "Kundalwalsaurabh56@gmail.com",
        domain: "3D Render Challenge",
        hash: "3DR005"
    },
    {
        name: "Vikas pal",
        email: "vikaspal968562@gmail.com",
        domain: "Gaming Montage Making",
        hash: "GMM001"
    },
    {
        name: "AMPADY B R",
        email: "me220003008@iiti.ac.in",
        domain: "Gaming Montage Making",
        hash: "GMM002"
    },
    {
        name: "B.Dinesh",
        email: "bandidineshlakshman@gmail.com",
        domain: "Gaming Montage Making",
        hash: "GMM003"
    },
    {
        name: "B.G.V.Shiva",
        email: "ee220002029@iiti.ac.in",
        domain: "Gaming Montage Making",
        hash: "GMM004"
    },
    {
        name: "Hrishikesh Hiremath",
        email: "me220003037@iiti.ac.in",
        domain: "Gaming Montage Making",
        hash: "GMM005"
    },
    {
        name: "Garv Jain",
        email: "garv2509@gmail.com",
        domain: "Gaming Montage Making",
        hash: "GMM006"
    },
    {
        name: "Harshit Gupta",
        email: "mems220005026@iiti.ac.in",
        domain: "Gaming Montage Making",
        hash: "GMM007"
    },
    {
        name: "Prakhar Keshari",
        email: "mt2202102010@iiti.ac.in",
        domain: "Kalamkaar",
        hash: "KLM001"
    },
    {
        name: "Anshul R",
        email: "anshulrathore546@gmail.com",
        domain: "Kalamkaar",
        hash: "KLM002"
    },
    {
        name: "Mayank Ramnani",
        email: "phd2201101004@iiti.ac.in",
        domain: "Kalamkaar",
        hash: "KLM003"
    },
    {
        name: "Devpreet",
        email: "devbhawsar2001@gmail.com",
        domain: "Kalamkaar",
        hash: "KLM004"
    },
    {
        name: "Ananthu M P",
        email: "paradoxproduction2022@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC001"
    },
    {
        name: "Stalan Renzo",
        email: "varunrenzo@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC002"
    },
    {
        name: "charan Kumar",
        email: "varunrenzo@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC003"
    },
    {
        name: "Joel Paulraj",
        email: "varunrenzo@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC004"
    },
    {
        name: "Sanjay Christy",
        email: "varunrenzo@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC005"
    },
    {
        name: "Swapnil Joshi",
        email: "joshiswapnil2004@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC006"
    },
    {
        name: "Vinayak Varun",
        email: "joshiswapnil2004@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC007"
    },
    {
        name: "Akshay Kumar Verma",
        email: "joshiswapnil2004@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC008"
    },
    {
        name: "Himanshi Mandloi",
        email: "joshiswapnil2004@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC009"
    },
    {
        name: "Sujal jaiswar",
        email: "2020jaiswar@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC010"
    },
    {
        name: "Anushka Sharma",
        email: "joshiswapnil2004@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC011"
    },
    {
        name: "Sanskar Sharma",
        email: "joshiswapnil2004@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC012"
    },
    {
        name: "Abhi Garg",
        email: "joshiswapnil2004@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC013"
    },
    {
        name: "Harsh Jain",
        email: "joshiswapnil2004@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC014"
    },
    {
        name: "Aman Agrawal",
        email: "joshiswapnil2004@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC015"
    },
    {
        name: "Sourav J Raju",
        email: "paradoxproduction2022@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC016"
    },
    {
        name: "Alen Thomas",
        email: "paradoxproduction2022@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC017"
    },
    {
        name: "Vaisakh R Nair",
        email: "paradoxproduction2022@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC018"
    },
    {
        name: "Keerthana Suresh P",
        email: "paradoxproduction2022@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC019"
    },
    {
        name: "Barath Biju",
        email: "paradoxproduction2022@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC020"
    },
    {
        name: "Fuhad Sanin",
        email: "paradoxproduction2022@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC021"
    },
    {
        name: "Rosu J Edanad",
        email: "paradoxproduction2022@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC022"
    },
    {
        name: "Hena Maria Biju",
        email: "paradoxproduction2022@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC023"
    },
    {
        name: "Reo George",
        email: "paradoxproduction2022@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC024"
    },
    {
        name: "Aparna Pradeep",
        email: "paradoxproduction2022@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC025"
    },
    {
        name: "Amith Sunil",
        email: "paradoxproduction2022@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC026"
    },
    {
        name: "Noel Paul George",
        email: "paradoxproduction2022@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC027"
    },
    {
        name: "Nihal Muhammed Riyaz",
        email: "paradoxproduction2022@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC028"
    },
    {
        name: "Nandkishor R",
        email: "paradoxproduction2022@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC029"
    },
    {
        name: "Edwin Alex Shaji",
        email: "paradoxproduction2022@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC030"
    },
    {
        name: "Athul M E",
        email: "paradoxproduction2022@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC031"
    },
    {
        name: "Jerishab M",
        email: "paradoxproduction2022@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC032"
    },
    {
        name: "Sparsh Verma",
        email: "sparshverma2305@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC033"
    },
    {
        name: "Shriya Gupta",
        email: "sparshverma2305@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC034"
    },
    {
        name: "Sagar Kashyap",
        email: "sparshverma2305@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC035"
    },
    {
        name: "Sandhya Kuntal",
        email: "sparshverma2305@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC036"
    },
    {
        name: "Pardeep Jangra",
        email: "sparshverma2305@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC037"
    },
    {
        name: "Himanshu Patle",
        email: "himanshupatle78@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC038"
    },
    {
        name: "Aarushi Igatpurikar",
        email: "himanshupatle78@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC039"
    },
    {
        name: "Gayatri Naxikar",
        email: "himanshupatle78@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC040"
    },
    {
        name: "Faisal Khan",
        email: "himanshupatle78@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC041"
    },
    {
        name: "Aditi Jaybhaye",
        email: "himanshupatle78@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC042"
    },
    {
        name: "Gargee Shinde",
        email: "himanshupatle78@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC043"
    },
    {
        name: "Firdous Sheikh",
        email: "himanshupatle78@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC044"
    },
    {
        name: "Divya Gaidhane",
        email: "himanshupatle78@gmail.com",
        domain: "Online Short Film Making",
        hash: "OSC045"
    }
]
